import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

/* Tarjeta de espacio. Se usa igual en la home (destacados) y en la
 * página de Locales, para que ambas hablen el mismo idioma visual. */

const PinIcon = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const ArrowIcon = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M5 12h14" />
    <path d="m12 5 7 7-7 7" />
  </svg>
);

function EspacioCard({ espacio, chipCount = 2 }) {
  const { t } = useLanguage();
  const feats = espacio.features || [];
  /* La superficie va dentro de features (ej. "120 m²"): se separa para
   * poder destacarla con su propio estilo. */
  const size = feats.find((f) => /m²|m2|sqm/i.test(f));
  const rest = feats.filter((f) => f !== size).slice(0, chipCount);

  return (
    <Link to={`/locales/${espacio.detailSlug}`} className="espacio-card">
      <div className="espacio-card-media">
        <img
          src={espacio.src}
          alt={espacio.alt}
          width="800"
          height="600"
          loading="lazy"
        />
        <span className="espacio-card-type">
          {espacio.isCoworking ? t('detalle.coworkingBadge') : t('detalle.localBadge')}
        </span>
        <span className="espacio-card-status">
          <span className="status-dot" aria-hidden />
          {t('carousel.available')}
        </span>
      </div>
      <div className="espacio-card-body">
        <h3 className="espacio-card-title">{espacio.location}</h3>
        <p className="espacio-card-address">
          <PinIcon />
          {espacio.overlayText}
        </p>
        {(size || rest.length > 0) && (
          <div className="espacio-card-chips">
            {size && <span className="chip chip--size">{size}</span>}
            {rest.map((f) => (
              <span key={f} className="chip">{f}</span>
            ))}
          </div>
        )}
        <span className="espacio-card-link">
          {t('carousel.viewDetails')}
          <ArrowIcon />
        </span>
      </div>
    </Link>
  );
}

export default EspacioCard;
